export const monitoringOptions = [
  'choose-monitoring',
  'change-monitoring'
] as const

export type MonitoringChoiceType = (typeof monitoringOptions)[number]
